import { dataHooks } from '@wix/data-hooks';
import { ThemeId } from '../../context/ThemeContext/constants/themeId';

export const themePickerButtonDataHooks = dataHooks<{
  themeTitle: {};
  fontIcon: { themeId: ThemeId | null };
  colorBullet: { color: string };
  activeIcon: {};
}>('theme-picker-button');
